import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';
import ListItemButton from '@mui/material/ListItemButton';
import { Link, useLocation } from 'react-router-dom';
import PowerIcon from '@mui/icons-material/Power';
import PieChartIcon from '@mui/icons-material/PieChart';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button, Card, CardActions, Paper, Stack, useMediaQuery, useTheme, Tooltip } from '@mui/material';
import { GasMeter, GraphicEq, Grid3x3Outlined, NotificationsOutlined, Palette, PieChartSharp, SmartButton, SolarPower } from '@mui/icons-material'
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import MonitorIcon from '@mui/icons-material/Monitor';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SpaIcon from '@mui/icons-material/Spa';
import AllOutIcon from '@mui/icons-material/AllOut';
import ReportIcon from '@mui/icons-material/Report';
import AnchorIcon from '@mui/icons-material/Anchor';
import DetailsIcon from '@mui/icons-material/Details';
// import { AuthenticationContext } from '../../context/AuthenticationContext';
import { useState } from 'react';
import { useEffect } from 'react';
import Image from 'mui-image';

import ColorPaletteDialog from '../palette/ColorPaletteDialog';
import { LightTheme } from '../../Themes/MyTheme';
import { BusinessAuthenticationContext } from '../../context/BussinessAuthenticationContext';
// import Enert from "../../assets/img/logos/LT2logo.jpeg";
import Enert from "../../assets/img/logos/LTNewLogo.png";

// import { useThemeContext } from '../../context/ThemeContext';


// const drawerWidth = 130;

// function Header2({ isDrawerOpen, onToggleDrawer }) {
//     return (
//         <Box sx={{ display: "flex" }}>
//             <CssBaseline />

//             {/* App Bar */}
//             <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
//                 <Toolbar>
//                     <IconButton
//                         aria-label="open drawer"
//                         onClick={() => onToggleDrawer(!isDrawerOpen)}
//                         edge="start"
//                         color="inherit"
//                     >
//                         <MenuIcon />
//                     </IconButton>

//                     <Typography flexGrow={1} variant="h5">
//                         Dashboard
//                     </Typography>
//                 </Toolbar>
//             </AppBar>

//             {/* Sidebar Drawer */}
//             <Drawer
//                 variant="persistent"
//                 open={isDrawerOpen}
//                 sx={{
//                     width: isDrawerOpen ? drawerWidth : 0,
//                     flexShrink: 0,
//                     transition: "width 0.3s ease-in-out",
//                     [`& .MuiDrawer-paper`]: {
//                         width: isDrawerOpen ? drawerWidth : 0,
//                     },
//                 }}
//             >
//                 <Toolbar />
//                 <Box sx={{ p: 2 }}>
//                     <Typography variant="body1">Sidebar Content</Typography>
//                 </Box>
//             </Drawer>
//         </Box>
//     );
// }

// export default Header2;



const drawerWidth = 70;

function Header2({ isDrawerOpen, onToggleDrawer }) {

    const { LoggedInUserInfoIn, logOutIn } = React.useContext(BusinessAuthenticationContext)

    const { palette, spacing, breakpoints, shape: { borderRadius } } = useTheme()
    const [colorPaletteDialogOpen, setColorPaletteDialogOpen] = useState(false);
    // const { updateThemeVariables } = useThemeContext();

    const handleColorPaletteDialogOpen = () => {
        setColorPaletteDialogOpen(true);
    };

    const handleColorPaletteSelect = (colors) => {

        // updateThemeVariables(updatedThemeVariables);

    };

    const handleColorPaletteDialogClose = () => {
        setColorPaletteDialogOpen(false);
    };







    // const { window } = props;
    const [currentTime, setCurrentTime] = useState(new Date());
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        // Clear the interval when the component is unmounted
        return () => clearInterval(intervalId);
    }, []); // Empty dependency array to run the effect only once on mount

    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const seconds = currentTime.getSeconds();
    const dates = currentTime.getDate()

    const year = currentTime.getFullYear();
    const month = currentTime.getMonth() + 1; // Months are 0-indexed
    const day = currentTime.getDate();

    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;


    const [open, setOpen] = useState(true);

    // const { logOutIn } = React.useContext(AuthenticationContext)
    // const { logOutIn } = React.useContext(AuthenticationContext)
    const [selectedIndex, setSelectedIndex] = useState(0);
    const location = useLocation()
    const laptopSize = useMediaQuery(breakpoints.down('xl'))
    const isLarge = useMediaQuery(breakpoints.up('xl'))
    const matchUpMd = useMediaQuery(breakpoints.up('lg'))

    // Close the drawer when the screen size is tablet
    useEffect(() => {
        if (laptopSize) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    }, [laptopSize])

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };



    const drawer = (
        <Box
            color={'primary.light'}

            sx={{
                height: '100%',
                borderRight: 1,
                borderRightColor: '#b4b4b4',
                bgcolor: '#b4b4b4',
            }}>
            <Stack sx={{ pt: spacing(1) }} alignItems={'center'} rowGap={spacing(1)}>
                <Card>
                    <CardActions>
                        {/* <Image fit='contain' alt="Remy Sharp" src={require('../../assets/img/logos/LTlogo.jpeg').default} /> */}
                        {/* <img
                            src={Enert}
                            alt="Logo"
                            style={{
                                width: 'auto',
                                height: '2rem',
                                maxWidth: '100%',
                                objectFit: 'contain',
                                borderRadius: "16px"
                            }}
                        /> */}
                        <img
                            src={Enert}          // Ensure this is a transparent-background logo
                            alt="Logo"
                            style={{
                                width: '6rem',     // increase size for visibility
                                height: 'auto',    // maintain aspect ratio
                                objectFit: 'contain',
                                display: 'block',
                            }}
                        />
                    </CardActions>
                </Card>
                {/* <Typography variant='body1'>eSolar Plant Monitoring System</Typography> */}
            </Stack>
            <List
                sx={{
                    '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: 'primary.light',
                        '&, & .MuiListItemIcon-root': {
                            color: 'background.default',
                        },
                    },
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: 'primary.light',
                        '&, & .MuiListItemIcon-root': {
                            color: 'primary.main',
                        },
                        '&, & .ListItemText-root': {
                            color: 'background.default',
                        },
                    },
                }}
                component="nav"
                aria-label="main mailbox folders"
            >

                {/* Dashboard */}
                <Tooltip title="Dashboard" placement="right" arrow>
                    <ListItemButton
                        onClick={() => isLarge ? null : setOpen(false)}
                        selected={location.pathname === '/'}
                        LinkComponent={Link}
                        to="."
                    >
                        <ListItemIcon>
                            <PieChartIcon sx={{ fontSize: '1.3rem', color: 'black' }} />
                        </ListItemIcon>
                    </ListItemButton>
                </Tooltip>

                {/* Business Location */}
                {LoggedInUserInfoIn.GROUP_LIST === "1" && (
                    <Tooltip title="Geographical-Location" placement="right" arrow>
                        <ListItemButton
                            onClick={() => isLarge ? null : setOpen(false)}
                            selected={location.pathname === '/businessLocation'}
                            LinkComponent={Link}
                            to="businessLocation"
                        >
                            <ListItemIcon>
                                <AddLocationAltRoundedIcon sx={{ fontSize: '1.3rem', color: 'black' }} />
                            </ListItemIcon>
                        </ListItemButton>
                    </Tooltip>
                )}

                {/* Group List */}
                {LoggedInUserInfoIn.GROUP_LIST === "1" && (
                    <Tooltip title="Group List" placement="right" arrow>
                        <ListItemButton
                            onClick={() => isLarge ? null : setOpen(false)}
                            selected={location.pathname === '/businessGroupList'}
                            LinkComponent={Link}
                            to="businessGroupList"
                        >
                            <ListItemIcon>
                                <SolarPower sx={{ fontSize: '1.3rem', color: 'black' }} />
                            </ListItemIcon>
                        </ListItemButton>
                    </Tooltip>
                )}

                {/* Logout */}
                <Tooltip title="Logout" placement="right" arrow>
                    <ListItemButton onClick={() => logOutIn()}>
                        <ListItemIcon>
                            <LoginIcon sx={{ fontSize: '1.3rem', color: 'black' }} />
                        </ListItemIcon>
                    </ListItemButton>
                </Tooltip>
            </List>

        </Box>
    );

    return (
        <Box sx={{ display: "flex" }}>
            <CssBaseline />

            {/* App Bar */}
            <AppBar
                position="fixed"
                elevation={2}
                sx={(theme) => ({
                    backgroundColor: `${theme.palette.primary.main} !important`,
                    zIndex: theme.zIndex.drawer + 1,
                })}
            >
                <Toolbar>
                    <IconButton
                        aria-label="open drawer"
                        onClick={() => onToggleDrawer(!isDrawerOpen)}
                        edge="start"
                        color="inherit"
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography flexGrow={1} component="div" sx={{ pl: spacing(1), display: "flex", columnGap: spacing(1), alignItems: "center" }}>
                        <PieChartSharp sx={{ fontSize: '1.3rem', color: "white" }} />
                        <Typography variant="h5"> Lauritz Knudsen</Typography>
                    </Typography>

                    <Box direction={'row'} alignItems={'center'} justifyContent={'flex-end'}>

                        <Box flex={1} display={'flex'} alignItems={'center'}>

                            {/* Timing */}

                            <Box flex={1} sx={{ display: { sm: 'none', xs: 'none', md: 'none', lg: 'flex', xl: 'flex' } }} columnGap={spacing(1)} alignItems={'center'}>
                                <Typography variant="body2" noWrap> {dates} / {month} / {year} </Typography>
                                <Stack p={spacing(1)} component={Card} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography noWrap variant='body2' textAlign={'center'}>
                                        {formattedHours}:{minutes < 10 ? `0${minutes}` : minutes}:
                                        {seconds < 10 ? `0${seconds}` : seconds}
                                    </Typography>
                                    <Typography variant='body2'> {ampm}</Typography>
                                </Stack>
                            </Box>

                            {/* Timing */}
                            <IconButton size='small' color='inherit'>
                                <NotificationsOutlined />
                            </IconButton>

                            {/* <Paper>

                                <img
                                    src={Enert}
                                    alt="Logo"
                                    style={{
                                        objectFit: 'contain',
                                        width: '4rem',
                                        height: '2rem',
                                        // borderRadius: "16px"

                                    }}
                                />
                            </Paper> */}

                            <Paper
                                elevation={0}
                                sx={{
                                    backgroundColor: 'transparent', // no paper background color
                                    padding: '4px',                  // optional padding around image
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src={Enert}          // Ensure this is a transparent-background logo
                                    alt="Logo"
                                    style={{
                                        width: '6rem',     // increase size for visibility
                                        height: 'auto',    // maintain aspect ratio
                                        objectFit: 'contain',
                                        display: 'block',
                                    }}
                                />
                            </Paper>


                            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    startIcon={<LoginIcon sx={{ fontSize: '1.3rem', color: "white" }} />}
                                    variant="contained"
                                    color="primary"

                                    onClick={() => {
                                        console.log("Logout button clicked");
                                        logOutIn();
                                    }}

                                >

                                    Logout
                                </Button>
                            </Box>

                        </Box>
                    </Box>

                </Toolbar>
            </AppBar>

            {/* Sidebar Drawer */}
            <Drawer
                variant="persistent"
                open={isDrawerOpen}
                sx={{
                    width: isDrawerOpen ? drawerWidth : 0,
                    flexShrink: 0,
                    transition: "width 0.3s ease-in-out",
                    [`& .MuiDrawer-paper`]: {
                        width: isDrawerOpen ? drawerWidth : 0,
                    },
                }}
            >
                <Toolbar />
                {/* <Box sx={{ p: 1}}>
                    <Typography variant="body1">{drawer}</Typography>
                </Box> */}
                {drawer}
            </Drawer>


            {/* <Box
                component="main"
                sx={{ flexGrow: 1, p: spacing(1), width: `calc(100% - ${drawerWidth}px)` }}>
                <Toolbar />

                {children}

            </Box> */}
            
            <ColorPaletteDialog
                open={colorPaletteDialogOpen}
                onClose={handleColorPaletteDialogClose}
                onSelectColors={handleColorPaletteSelect}
            />

        </Box>
    );
}

export default Header2;
